module.exports = __webpack_public_path__ + "static/media/airblitz-logo.4e855fc6.png";